import React from 'react';
import ReactDOM from 'react-dom/client';
import { App as AntApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import App from './App';
import ControlApp from './ControlApp';
import { AdminErrorBoundary } from './components/AdminErrorBoundary';
import './styles.css';

const isControlPage = window.location.pathname === '/control' || window.location.pathname.startsWith('/control/');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={{
      token: {
        colorPrimary: '#14b8a6',
        colorInfo: '#14b8a6',
        borderRadius: 10,
        fontFamily: 'Inter, "PingFang SC", "Microsoft YaHei", sans-serif',
        colorBgLayout: '#f3f6f9',
      },
      components: {
        Layout: { siderBg: '#07111f', headerBg: '#ffffff' },
        Menu: { darkItemBg: '#07111f', darkSubMenuItemBg: '#07111f', darkItemSelectedBg: '#123a3b', darkItemSelectedColor: '#6ee7dc' },
        Table: { headerBg: '#f7f9fb', headerColor: '#52606d' },
      },
    }}>
      <AdminErrorBoundary>
        <AntApp>{isControlPage ? <ControlApp /> : <App />}</AntApp>
      </AdminErrorBoundary>
    </ConfigProvider>
  </React.StrictMode>,
);
